module.exports = __webpack_public_path__ + "TERRAZA_TAMBO.png?421a5c22f85761583a930277675f527f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TERRAZA_TAMBO.png
// module id = 486
// module chunks = 2